import React from 'react'
import {
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react'
import { Field, FieldProps } from 'formik'

export interface FormInputProps {
  name: string
  label: string
  isRequired?: boolean
}

export const FormDateTime: React.FC<FormInputProps> = ({
  name,
  label,
  isRequired = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        return (
          <FormControl
            name={name}
            isInvalid={!!(form.errors[name] && form.touched[name])}
            isRequired={isRequired}
            mb={3}
          >
            <FormLabel fontSize="xs" htmlFor={name}>
              {label}
            </FormLabel>
            <Input {...field} type="datetime-local" width="auto" />
            <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
          </FormControl>
        )
      }}
    </Field>
  )
}
